import { IconButton } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { GridOverlay } from '@material-ui/data-grid';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../../../../App/AppContext';
import { SecondaryButton } from '../../../../Core/FormInput/index';
import DataGridComp from '../../../../Core/Grid';
import AddDepartmentCodesModal from './AddUpdateModal';
import { getDepartmentCodes } from '../../../../Core/Service/ReportingCodes-service';

const DepartmentCodes = (props) => {
    const [state, setState] = useState({
        rows: [],
        show: false,
        code: []
    });
    const { showToast } = useContext(AppContext);

    useEffect(async () => {
        pullDepartmentCodesAndUpdateState();
    }, []);

    const handleUpdate = (params) => {
        setState((st) => {
            const nst = {
                ...st,
                show: true,
                code: params.value.row.id
            };
            return nst;
        });
    };

    const Arrow = (params) => {
        return (
            <>
                <Tooltip title="Update Reporting Codes" aria-label="add">
                    <IconButton size="small" onClick={() => handleUpdate(params)}>
                        <EditOutlinedIcon color="secondary" fontSize="small" />
                    </IconButton>
                </Tooltip>
            </>
        );
    };

    const column_new = [
        {
            field: '',
            headerName: 'Action',
            sortable: false,
            width: 80,
            renderCell: (params) => <Arrow value={params} />
        },
        {
            field: 'id', //reportingCode
            headerName: 'Reporting Code',
            width: 240
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 340
        },
        {
            field: 'partDesc',
            headerName: 'Part Description',
            width: 330
        },
        {
            field: 'agedQueriesDesc',
            headerName: 'Aged Queries Description',
            width: 310
        },
        {
            field: 'seq',
            headerName: 'Sequence',
            width: 250
        },
        ,
        {
            field: 'inReporting',
            headerName: 'In Reporting?',
            width: 290
        }
    ];

    const pullDepartmentCodesAndUpdateState = async () => {
        let result = await getDepartmentCodes();

        if (result.success) {
            setState((st) => ({
                ...st,
                rows: result.data.list.map((w) => ({
                    ...w,
                    id: w.code
                })),
                show: false
            }));
        }
        if (!result.success) {
            showToast(result.message);
        }
    };

    const handleAdd = (props) => {
        setState((st) => {
            return {
                ...st,
                show: true,
                code: null
            };
        });
    };

    function CustomNoRowsOverlay() {
        return (
            <GridOverlay>
                <div>No Reporting Codes Available</div>
            </GridOverlay>
        );
    }

    const closeUpdateUser = (refreshGrid) => {
        setState((st) => ({ ...st, show: false }));
        refreshGrid && pullDepartmentCodesAndUpdateState();
    };

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', right: 0 }}>
                <SecondaryButton variant="contained" color="secondary" onClick={handleAdd} className="btnadd">
                    Add Department Code
                </SecondaryButton>
            </div>
            {state.show ? <AddDepartmentCodesModal onFormSubmit={closeUpdateUser} code={state.code} /> : null}
            <Breadcrumbs separator=">>" aria-label="breadcrumb">
                <Link color="inherit" to={'/'}>
                    Home
                </Link>
                <Typography color="secondary" style={{ fontSize: '0.85rem' }}>
                    Department Codes
                </Typography>
            </Breadcrumbs>
            <DataGridComp rows={state.rows} columns={column_new} enableSearch={true} offset={250} CustomNoRowsOverlay={CustomNoRowsOverlay} />
        </div>
    );
};
export default DepartmentCodes;
